import React, { useState } from 'react'
import { Copy, Check } from 'lucide-react'
import { useWorkflow } from '@/lib/contexts/workflow-context'
import { useToast } from '@/hooks/use-toast'

const CopyPasteButtons = ({ nodeId, nodeType, nodeName, className = "" }) => {
  const { copyNode, currentWorkflow } = useWorkflow()
  const { toast } = useToast()
  const [copySuccess, setCopySuccess] = useState(false)

  const handleCopy = async (e) => {
    e.stopPropagation()
    
    if (!currentWorkflow) {
      toast({
        title: "Error",
        description: "No workflow selected",
        variant: "destructive"
      })
      return
    }

    const success = copyNode(nodeId, currentWorkflow.id)
    
    if (success) {
      setCopySuccess(true)
      toast({
        title: "Node Copied",
        description: `${nodeName || nodeType} has been copied to clipboard`,
      })
      
      // Reset success state after 2 seconds
      setTimeout(() => setCopySuccess(false), 2000)
    } else {
      toast({
        title: "Copy Failed",
        description: "Failed to copy node",
        variant: "destructive"
      })
    }
  }

  return (
    <div className={`copy-paste-buttons ${className}`}>
      <button
        onClick={handleCopy}
        className="text-[#64748b]"
        title={`Copy ${nodeName || nodeType}`}
        disabled={copySuccess}
      >
        {copySuccess ? <Check size={14} /> : <Copy size={14} />}
      </button>
    </div>
  )
}

export default CopyPasteButtons